import { atom } from 'jotai';
import { NewsItem } from './types';
import { defaultFeeds } from './defaultFeeds';

export const feedsAtom = atom<NewsItem[]>(defaultFeeds);
export const loadingAtom = atom<boolean>(true);
export const errorAtom = atom<string | null>(null);